import NoteConstants from 'notebook/notes/NoteConstants';
import {PreviewProps} from 'notebook/notes/previews/PreviewMixin';
import usePreviewMixin from 'notebook/notes/previews/usePreviewMixin';

export default function EntryPreview(props: PreviewProps): JSX.Element {
  const {render} = usePreviewMixin({
    ...props,
    className: 'note-entry',
    noteType: NoteConstants.ENTRY,
    renderItem: () => null,
  });
  return render();
}
